import * as Sentry from "@sentry/react";


Sentry.init({
    dsn: "https://849f12f6c784650e1e6bc7bde364f28f@o4509634649784320.ingest.de.sentry.io/4509634663546960",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.breadcrumbsIntegration({console: true}),
        Sentry.globalHandlersIntegration({onerror: true, onunhandledrejection: true}),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],

    tracesSampleRate: 1.0, // Performance monitoring - 1.0 = vše (pozor na cenu!)
    replaysSessionSampleRate: 1.0, // Session replay - 1.0 = vše (sniž pro produkci, drahé!)
    replaysOnErrorSampleRate: 1.0, // Při erroru vždy session replay
    maxBreadcrumbs: 100, // kolik breadcrumbů zpětně logovat
});
